import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const data = [['MP', 'María P.', 'Docente de Historia — Lima, Perú', 'Mis alumnos por fin entienden cómo conectar los procesos históricos entre sí. Ahora entro al aula con todo listo y con confianza.'], ['JR', 'Jorge R.', 'Profesor de Historia — Buenos Aires, Argentina', 'El material hace el trabajo pesado por mí. Nunca más llegué a una clase sin saber cómo explicar un período histórico complejo.'], ['CL', 'Claudia L.', 'Docente de nivel medio — Bogotá, Colombia', 'Las secuencias didácticas me ahorran horas. No improviso nunca más frente a mis alumnos.']];
export function TestimonialsStrip() {
  return <section className="bg-white px-4 py-12" data-id="element-193" data-mp="aim9g0mi7foa">
      <div className="mx-auto grid max-w-7xl gap-6 md:grid-cols-3" data-id="element-194" data-mp="2had9j74z530y">
        {data.map(([initials, name, role, text], i) => <motion.article key={name} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.12
      }} className="rounded-2xl border border-slate-100 bg-white p-6 shadow-[0_8px_24px_rgba(16,42,67,.08)]" data-id="element-195" data-mp="2cdmu8m0zubgl" data-mpi={i}>
            <div className="mb-4 flex text-gold" data-id="element-196" data-mp="v2fak85bjb21">
              {Array.from({
            length: 5
          }, (_, j) => <Star key={j} size={15} fill="currentColor" data-id="element-197" data-mp="143djn4um68rh" />)}
            </div>
            <p className="mb-5 text-sm italic leading-relaxed text-ink" data-id="element-198" data-mp="191x410tk7chq">
              “{text}”
            </p>
            <div className="flex items-center gap-3" data-id="element-199" data-mp="35wjray42qgq9">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#F8F0DA] text-sm font-bold text-navy" data-id="element-200" data-mp="3au35xz4ooviq">
                {initials}
              </span>
              <div data-id="element-201" data-mp="i1yzbcluyx0o">
                <strong className="block text-sm text-navy" data-id="element-202" data-mp="d11fkvl79ux2">{name}</strong>
                <span className="text-xs text-slate-500" data-id="element-203" data-mp="d2urapao75bx">{role}</span>
              </div>
            </div>
          </motion.article>)}
      </div>
    </section>;
}